export const TEXT_SPLIT_LENGTH = 3;
